/**
 * 将"2020-06-29T02:33:55.000 0000"转换成时间日期格式的
 * */
export function dateStr2Timestamp(str) {
  let d = new Date(str)
  let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
  let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
  let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
  let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
  let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
  let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec
  return times
}

/**
 * 不带小时分钟的
 * @param str
 * @returns {string}
 */
export function dateStr2Times(str) {
  let d = new Date(str)
  let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
  let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
  let times = d.getFullYear() + '-' + month + '-' + day
  return times
}

/**
 *格式化时间日期
 * @param date
 * @param fmt
 * @returns {*}
 */
export function formatDate(date, fmt) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}



// WEBPACK FOOTER //
// ./src/util/TimeTransition.js